var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useTranslation } from 'react-i18next'; // 导入 useTranslation
// 使用 require 引入 antd 组件，避免找不到模块错误
import { Layout, Typography, Space, Dropdown, Menu, Button, Modal, Radio, Tooltip } from 'antd';
import { FolderOutlined, GlobalOutlined, ClearOutlined, FileTextOutlined } from '@ant-design/icons';
import api from '@/api'; // 导入 api
import i18n from '@/utils/i18nService'; // 导入 i18n 实例
import { useState, useEffect } from 'react';
const { Header: AntHeader } = Layout;
const { Title } = Typography;
const Header = ({ onClearAll, onImportSuccess, competitionType, projectTech, theme, athleteName, organization, competitionName, dataTableData, }) => {
    const { t } = useTranslation();
    const [exportFormat, setExportFormat] = useState('excel'); // 添加状态来存储选中的导出格式
    const [isExportModalVisible, setIsExportModalVisible] = useState(false); // 控制导出弹窗的显示与隐藏
    useEffect(() => {
        // 语言初始化已在 index.tsx 中处理，此处无需重复
    }, []);
    //ProjectList
    const ProjectList = [
        {
            label: t('main_controls.solo_tech_female'),
            value: 'W_SOLO_TECH',
        },
        {
            label: t('main_controls.solo_tech_male'),
            value: 'M_SOLO_TECH',
        },
        {
            label: t('main_controls.duet_tech'),
            value: '-_DUET_TECH',
        },
        {
            label: t('main_controls.mixed_duet_tech'),
            value: 'X_MIXED_DUET_TECH',
        },
        {
            label: t('main_controls.team_tech'),
            value: '-_TEAM_TECH',
        },
        {
            label: t('main_controls.acrobatic'),
            value: '-_ACROBATIC',
        },
        {
            label: t('main_controls.solo_free_female'),
            value: 'W_SOLO_FREE',
        },
        {
            label: t('main_controls.solo_free_male'),
            value: 'M_SOLO_FREE',
        },
        {
            label: t('main_controls.duet_free'),
            value: '-_DUET_FREE',
        },
        {
            label: t('main_controls.mixed_duet_free'),
            value: 'X_MIXED_DUET_FREE',
        },
        {
            label: t('main_controls.team_free'),
            value: '-_TEAM_FREE',
        }, {
            label: t('main_controls.free_combination'),
            value: '-_FREE_COMBINATION',
        },
    ];
    //eventphaseList
    const eventphaseList = [
        {
            label: t('main_controls.final'),
            value: 'final',
        },
        {
            label: t('main_controls.preliminary'),
            value: 'preliminary',
        },
    ];
    const handleMenuClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // 调用 i18n 实例的 changeLanguage 方法
            yield i18n.changeLanguage(e.key);
            yield api.CoachCardApi.setLanguage({ language: e.key });
            //本地实时储存
            localStorage.setItem('language', e.key);
        }
        catch (error) {
        }
    });
    const menu = (<Menu onClick={handleMenuClick}>
      <Menu.Item key="zh_CN">{t('language.chinese')}</Menu.Item>
      <Menu.Item key="en_US">{t('language.english')}</Menu.Item>
    </Menu>);
    const handleGenerateCoachCard = () => {
        //调出弹框，让用户选择是生成excel还是生成pdf文件
        setExportFormat('excel'); // 每次打开弹窗时默认选中 Excel
        setIsExportModalVisible(true);
    };
    const handleClearAll = () => {
        Modal.confirm({
            title: '',
            content: t('modal.confirm_clear_all'),
            onOk() {
                onClearAll(); // 调用从父组件传递过来的函数
            },
            onCancel() {
                // 用户取消，不执行任何操作
            },
        });
    };
    const handleExportModalOk = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        try {
            const now = new Date();
            const year = now.getFullYear();
            const month = (now.getMonth() + 1).toString().padStart(2, '0');
            const day = now.getDate().toString().padStart(2, '0');
            const hours = now.getHours().toString().padStart(2, '0');
            const minutes = now.getMinutes().toString().padStart(2, '0');
            const seconds = now.getSeconds().toString().padStart(2, '0');
            const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            const res = yield api.CoachCardApi.exportCoachCard({
                format: exportFormat,
                game_name: competitionName,
                competitor_name: organization,
                eventphase_phase: ((_a = eventphaseList.find(item => item.value == competitionType)) === null || _a === void 0 ? void 0 : _a.label) || '',
                eventphase_name: ((_b = ProjectList.find(item => item.value == projectTech)) === null || _b === void 0 ? void 0 : _b.label) || '',
                theme: theme,
                athlete_name_list: athleteName ? athleteName.split(',').map(name => name.trim()) : [],
                data_collection_submit_time: formattedDateTime,
                elementList: dataTableData
                    .filter(item => item.time || item.part || item.baseScore || item.declaredDifficulty || item.bonus || item.difficultyValue) // 过滤掉所有关键字段都为空的行
                    .map((item, index) => ({
                    time: item.time,
                    part: item.part,
                    el: (Number(index) + 1).toString(),
                    base_mark_name: item.baseScore,
                    declared_difficulty: item.declaredDifficulty,
                    bonus: item.bonus,
                    difficulty_degree: item.difficultyValue
                }))
            });
            if (exportFormat == 'excel') {
                //响应对应的文件流,下载excel
                const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const projectLabel = ((_c = ProjectList.find(item => item.value == projectTech)) === null || _c === void 0 ? void 0 : _c.label) || '';
                const eventphaseLabel = ((_d = eventphaseList.find(item => item.value == competitionType)) === null || _d === void 0 ? void 0 : _d.label) || '';
                const filenameParts = [];
                if (projectLabel)
                    filenameParts.push(projectLabel);
                if (eventphaseLabel)
                    filenameParts.push(eventphaseLabel);
                if (organization)
                    filenameParts.push(organization);
                const filename = filenameParts.join('-');
                a.download = `${filename}.xlsx`;
                a.click();
                URL.revokeObjectURL(url);
            }
            if (exportFormat == 'pdf') {
                //响应对应的文件流,在浏览器新窗口中打开PDF
                const blob = new Blob([res.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                //在浏览器中打开新页面
                const projectLabel = ((_e = ProjectList.find(item => item.value == projectTech)) === null || _e === void 0 ? void 0 : _e.label) || '';
                const eventphaseLabel = ((_f = eventphaseList.find(item => item.value == competitionType)) === null || _f === void 0 ? void 0 : _f.label) || '';
                const filenameParts = [];
                if (projectLabel)
                    filenameParts.push(projectLabel);
                if (eventphaseLabel)
                    filenameParts.push(eventphaseLabel);
                if (organization)
                    filenameParts.push(organization);
                const filename = filenameParts.join('-');
                window.open(url, '_blank', `download=${filename}.pdf`);
                URL.revokeObjectURL(url);
            }
        }
        catch (error) {
            Modal.error({
                title: t('modal.error'),
                content: t('modal.export_failed'),
            });
        }
        setIsExportModalVisible(false);
    });
    const handleExportModalCancel = () => {
        setIsExportModalVisible(false);
    };
    const fileInputRef = React.useRef(null);
    const handleImportExcelClick = () => {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); // 触发隐藏的文件输入元素的点击事件
    };
    const handleFileChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        const files = event.target.files;
        if (files && files.length > 0) {
            const file = files[0];
            const formData = new FormData();
            formData.append('file', file);
            try {
                const res = yield api.CoachCardApi.importCoachCardExcel(formData);
                if (res.data && res.data.code === 200) {
                    Modal.success({
                        title: t('modal.success'),
                        content: t('modal.excel_import_success'),
                    });
                    onImportSuccess(res.data.data.elementList || []); // 调用回调函数，传递导入的数据
                }
                else {
                    Modal.error({
                        title: t('modal.error'),
                        content: res.data.msg || t('modal.excel_import_failed'),
                    });
                }
            }
            catch (error) {
                Modal.error({
                    title: t('modal.error'),
                    content: t('modal.excel_import_failed_network'),
                });
            }
            finally {
                // 清空文件输入，以便可以再次选择相同的文件
                event.target.value = '';
            }
        }
    });
    return (<div style={{ position: 'fixed', top: 0, width: '100%', zIndex: 1000 }}>
      <AntHeader style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'linear-gradient(to bottom, #5a08f1ff 0%, #ab12daff 100%)', padding: '0 60px', borderBottom: '1px solid #ccc' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Title level={3} style={{ margin: 0, color: '#fff' }}>{t('header.title')}</Title>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Dropdown overlay={menu} placement="bottomRight">
            <GlobalOutlined style={{ fontSize: '20px', color: '#fff', cursor: 'pointer' }}/>
          </Dropdown>
        </div>
      </AntHeader>
      <Space size="middle" direction="horizontal" style={{ background: 'rgb(249, 249, 249)', padding: '10px 20px' }}>
        <Tooltip title={t('header.import_excel')} placement="bottom" color="#930FE1">
          <Button icon={<FolderOutlined />} onClick={handleImportExcelClick}/>
        </Tooltip>
        <input type="file" ref={fileInputRef} onChange={handleFileChange} style={{ display: 'none' }} // 隐藏文件输入元素
     accept=".xls,.xlsx" // 限制文件类型为 Excel
    />
        <Tooltip title={t('header.clear_all')} placement="bottom" color="#930FE1">
          <Button icon={<ClearOutlined />} onClick={handleClearAll}/>
        </Tooltip>
        <Button style={{ backgroundColor: '#930FE1', color: '#fff' }} icon={<FileTextOutlined />} onClick={handleGenerateCoachCard}>
          {t('header.generate_card')}
        </Button>
        <Modal title={t('modal.export_file')} open={isExportModalVisible} onOk={handleExportModalOk} onCancel={handleExportModalCancel} okText={t('modal.confirm_export')} cancelText={t('modal.cancel')}>
          <div style={{ marginTop: 16 }}>
            <div style={{ marginBottom: 8 }}>{t('modal.select_export_format')}</div>
            <Radio.Group onChange={(e) => setExportFormat(e.target.value)} value={exportFormat}>
              <Radio value="excel"> {t('modal.excel_file')}</Radio>
              <Radio value="pdf"> {t('modal.pdf_file')}</Radio>
            </Radio.Group>
          </div>
        </Modal>
      </Space>
    </div>);
};
export default Header;
